import axios from 'axios';
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '' : '/api/';

axios.interceptors.request.use((config) => {
    if (config.method === 'post' && !(config.data instanceof FormData)) {
        const data = config.data;
        const formData = new FormData();
        for (const key in data) {
            if (key === '') {
                continue;
            }
            if (typeof data[key] === 'string') {
                data[key] = data[key].replace(/[\b\f\t\v]/g, '');
            }
            if (data[key] === null || data[key] === '' || data[key] === undefined || (typeof (data[key]) === 'number' && isNaN(data[key]))) {
                continue;
            }
            formData.append(key, data[key]);
        }
        config.data = formData;
    }
    return config;
});

axios.interceptors.response.use((response) => {
    // if (response.data.code === 901) {
    //     localStorage.removeItem('loginToken');
    //     ElMessageBox.confirm('登录已失效，请重新登录', '提示', {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //         showCancelButton: false,
    //         type: 'warning'
    //     }).then(() => {
    //         VueRouter.push({ name: 'login' }).catch(() => {
    //             // do nothing
    //         });
    //     }).catch(() => {
    //         VueRouter.push({ name: 'login' }).catch(() => {
    //             // do nothing
    //         });
    //     });
    // }
    return response.data;
});

export default axios;
